/**
 * Showcase reducer:
 * bg, banner
 *
 *
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 19.04.2016.
 */

import _get from 'lodash/get';

import {PendingState, SuccessState, ErrorState} from '../../utils';
import {GET_BG_SHOWCASE, GET_BANNERS_SHOWCASE} from '../../actions/showcase/actions-showcase'
import Config from '../../config';

let INIT_STATE = {
  background: {
    id: null,
    slider: [],
    slider_delay: _get(Config, 'background_slider_delay', 10000)
  },
  banners: {
    id: null,
    slider: [],
    slider_delay: _get(Config, 'banners_slider_delay', 10000)
  }
};

export default function (state = INIT_STATE, action) {

  switch (action.type) {
    case SuccessState(GET_BG_SHOWCASE):
      return {...state, background: action.payload};

    case SuccessState(GET_BANNERS_SHOWCASE):
      return {...state, banners: action.payload};

     case ErrorState(GET_BG_SHOWCASE):
      return {...state, background: INIT_STATE.background};

    case ErrorState(GET_BANNERS_SHOWCASE):
      return {...state, banners: INIT_STATE.banners};

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/showcase/reducer-showcase.js